import PageContainerBlank from '../../components/PageContainer/PageContainerBlank';
import PageEndBlank from '../../components/PageContainer/PageEndBlank';
import Gallery from '../../components/Gallery/Gallery';
import katex from 'katex';
import 'katex/dist/katex.min.css';

const PreviousEvents = () => {
	const CROSSES_LATEX_SUM = katex.renderToString('\\sum_{i=0}^{27} (i+5) = 518');
	return (
		<div>
			<PageContainerBlank />

			<h1>Installing Pro-Life Crosses</h1>
			<h3>October 1, 2026</h3>
			<Gallery height="50%" imageInfos={[
				{
					width: 1455,
					height: 967,
					image: <img src="/static/images/events/2026/Crosses/cross1.webp" alt="Pro-Life Crosses" />,
				},
				{
					width: 1125,
					height: 1425,
					image: <img src="/static/images/events/2026/Crosses/cross2.webp" alt="Pro-Life Crosses" />,
				},
				{
					width: 2000,
					height: 1125,
					image: <img src="/static/images/events/2026/Crosses/cross3.webp" alt="Pro-Life Crosses" />,
				},
			]} />
			<Gallery height="50%" imageInfos={[
				{
					width: 2000,
					height: 1125,
					image: <img src="/static/images/events/2026/Crosses/cross4.webp" alt="Pro-Life Crosses" />,
				},
				{
					width: 2000,
					height: 1125,
					image: <img src="/static/images/events/2026/Crosses/cross5.webp" alt="Pro-Life Crosses" />,
				},
				{
					width: 1944,
					height: 1300,
					image: <img src="/static/images/events/2026/Crosses/cross6.webp" alt="Pro-Life Crosses" />,
				},
			]} />
			<p className="justify"><span className="tab"></span>It was a hot day for cross installation. The Holy Name men helped drive <span dangerouslySetInnerHTML={{ __html: CROSSES_LATEX_SUM }} /> crosses into the ground over the course of an afternoon hour&mdash; which is the same total as last year, though there was some trouble with counting them all this time around. The traditional pro-life cookies were available to snack on afterward.</p>
			<br />

			<h1>Ordination to the Diaconate</h1>
			<h3>September 12, 2026</h3>
			<Gallery height="100%" imageInfos={[
				{
					width: 899,
					height: 622,
					image: <img src="/static/images/events/2026/Ordination/Gospel.webp" alt="Jeff's Ordination" />,
				},
				{
					width: 1940,
					height: 1436,
					image: <img src="/static/images/events/2026/Ordination/NewDeacons.jpg" alt="Jeff's Ordination" />,
				},
				{
					width: 1048,
					height: 1640,
					image: <img src="/static/images/events/2026/Ordination/Certificate.webp" alt="Jeff's Ordination" />,
				},
			]} />
			<p className="justify"><span className="tab"></span>Jeffrey Evich, one of our Holy Name men, was ordained as a permanent Deacon in the Cathedral of Saint Patrick. He was assigned at St. Joseph Parish, Hanover... so we're not losing him! A replay of the livestreamed ordination mass is available via <a href="https://www.youtube.com/live/nFri_TwUK94" target="_blank" rel="noopener noreferrer">this link</a>.</p>
			<br />

			<h1>Blue Mass</h1>
			<h3>September 11, 2026</h3>
			<Gallery height="100%" imageInfos={[
				{
					width: 1020,
					height: 700,
					image: <img src="/static/images/events/2026/BlueMass/patriot1.webp" alt="Blue Mass" />,
				},
				{
					width: 1020,
					height: 700,
					image: <img src="/static/images/events/2026/BlueMass/patriot2.webp" alt="Blue Mass" />,
				},
				{
					width: 2142,
					height: 1606,
					image: <img src="/static/images/events/2026/BlueMass/patriot3.webp" alt="Blue Mass" />,
				},
			]} />
			<p className="justify"><span className="tab"></span>Over 200 people attended this year's Blue Mass thanks to flyer distribution as early as August. It was such a crowd that we ran out of programs to give people at the entrance! The Holy Name men helped with preparing and serving refreshments while the 4th degree Knights of Columbus aided the Mass procession.</p>
			<br />

			<h1>Grandpa's Garage</h1>
			<h3>June 13, 2026</h3>
			<Gallery height="100%" imageInfos={[
				{
					width: 2065,
					height: 1312,
					image: <img src="/static/images/events/2026/GrandpasGarage/garage1.webp" alt="Grandpa's Garage" />,
				},
				{
					width: 2142,
					height: 1287,
					image: <img src="/static/images/events/2026/GrandpasGarage/garage2.webp" alt="Grandpa's Garage" />,
				},
				{
					width: 2142,
					height: 1606,
					image: <img src="/static/images/events/2026/GrandpasGarage/garage3.webp" alt="Grandpa's Garage" />,
				},
			]} />
			<p className="justify"><span className="tab"></span>This year's Grandpa's Garage accepted item donations on the evenings of June 9th, 10th, and 12th, with the actual sale being held the morning of the 13th. We brought in close to $3000, which is a great help to our acts of charity and to our new scholarship fund. A new member will also be joining us as a result of this event.</p>
			<br />

			<h1>PAL Lunch</h1>
			<h3>May 3, 2026</h3>
			<Gallery height="100%" imageInfos={[
				{
					width: 1988,
					height: 1110,
					image: <img src="/static/images/events/2026/PALLunch/pal1.webp" alt="PAL Lunch" />,
				},
				{
					width: 1261,
					height: 1363,
					image: <img src="/static/images/events/2026/PALLunch/pal2.webp" alt="PAL Lunch" />,
				},
				{
					width: 2046,
					height: 1010,
					image: <img src="/static/images/events/2026/PALLunch/pal3.webp" alt="PAL Lunch" />,
				},
			]} />
			<p className="justify"><span className="tab"></span>Six people helped prepare egg salad sandwiches with sides of fruit and chips for the PAL Lunch. Approximately 70 meals were served; 30 people living at the residence (including 4 or 5 children) were served first. The implementation of changes to meal serving now necessitate the recipients to scan a card and volunteers to serve drinks and silverware per request.</p>
			<br />

			<h1>The Feast of St. Joseph</h1>
			<h3>March 19, 2026</h3>
			<Gallery height="50%" imageInfos={[
				{
					width: 1451,
					height: 1257,
					image: <img src="/static/images/events/2026/StJosephFeast/joseph1.jpg" alt="The Feast of St. Joseph" />,
				},
				{
					width: 1512,
					height: 1028,
					image: <img src="/static/images/events/2026/StJosephFeast/joseph2.jpg" alt="The Feast of St. Joseph" />,
				},
				{
					width: 1028,
					height: 1428,
					image: <img src="/static/images/events/2026/StJosephFeast/joseph3.jpg" alt="The Feast of St. Joseph" />,
				},
			]} />
			<Gallery height="50%" imageInfos={[
				{
					width: 1824,
					height: 1912,
					image: <img src="/static/images/events/2026/StJosephFeast/joseph4.jpg" alt="The Feast of St. Joseph" />,
				},
				{
					width: 2000,
					height: 901,
					image: <img src="/static/images/events/2026/StJosephFeast/joseph5.jpg" alt="The Feast of St. Joseph" />,
				},
				{
					width: 1725,
					height: 941,
					image: <img src="/static/images/events/2026/StJosephFeast/joseph6.jpg" alt="The Feast of St. Joseph" />,
				},
			]} />
			<p className="justify"><span className="tab"></span>Bishop Senior celebrated this year's Feast and participated in the dinner afterward! There were 160 other attendees likewise served. Out of the fifty pans of baked ziti, eight were donated to the Hanover Area Council of Churches and some remainder were sold to the attendees.</p>
			<br />

			<h1>New Parishioner Ministry Fair</h1>
			<h3>March 1, 2026</h3>
			<Gallery imageInfos={[
				{
					width: 1857,
					height: 1087,
					image: <img src="/static/images/events/2026/NewParishionerFair/fair1.jpg" alt="The HNS Table" />,
				},
				{
					width: 1280,
					height: 720,
					image: <img src="/static/images/events/2026/NewParishionerFair/kodak.gif" alt="Digital frame of HNS pictures" />,
				},
				{
					width: 1316,
					height: 1125,
					image: <img src="/static/images/events/2026/NewParishionerFair/fair3.jpg" alt="The HNS Table snacks" />,
				},
				{
					width: 1576,
					height: 1125,
					image: <img src="/static/images/events/2026/NewParishionerFair/fair2.jpg" alt="Old HNS Minute books" />,
				},
			]} />
			<p className="justify"><span className="tab"></span>Having only planned to bring a digital frame showcasing the photos on this page, the Holy Name men pulled together some extra props for our table at the Ministry Fair. The Holy Name banners, artifacts, and snacks were all moved into position after seeing the extravagance of the other tables...</p>
			<br />

			<h1>HACC Christmas Dinner</h1>
			<h3>December 27, 2025</h3>
			<Gallery height="50%" imageInfos={[
				{
					width: 640,
					height: 480,
					image: <img src="/static/images/events/2025/HACCDinner/hacc1.jpg" alt="HACC Dinner" />,
				},
				{
					width: 640,
					height: 480,
					image: <img src="/static/images/events/2025/HACCDinner/hacc2.jpg" alt="HACC Dinner" />,
				},
				{
					width: 640,
					height: 480,
					image: <img src="/static/images/events/2025/HACCDinner/hacc3.jpg" alt="HACC Dinner" />,
				},
			]} />
			<Gallery height="50%" imageInfos={[
				{
					width: 640,
					height: 480,
					image: <img src="/static/images/events/2025/HACCDinner/hacc4.jpg" alt="HACC Dinner" />,
				},
				{
					width: 480,
					height: 640,
					image: <img src="/static/images/events/2025/HACCDinner/hacc5.jpg" alt="HACC Dinner" />,
				},
				{
					width: 480,
					height: 640,
					image: <img src="/static/images/events/2025/HACCDinner/hacc6.jpg" alt="HACC Dinner" />,
				},
			]} />
			<p className="justify"><span className="tab"></span>The HACC Christmas Dinner went very well. Sixteen pizzas were brought in from Genova's and all but three were eaten. Approximately 45 people attended, which included three teenagers and a little one.</p>
			<br />

			<h1>Nativity Setup</h1>
			<h3>December 5, 2025</h3>
			<Gallery height="50%" imageInfos={[
				{
					width: 640,
					height: 480,
					image: <img src="/static/images/events/2025/Nativity/nativity1.jpg" alt="Nativity setup" />,
				},
				{
					width: 640,
					height: 480,
					image: <img src="/static/images/events/2025/Nativity/nativity2.jpg" alt="Nativity setup" />,
				},
				{
					width: 480,
					height: 640,
					image: <img src="/static/images/events/2025/Nativity/nativity4.jpg" alt="Nativity setup" />,
				},
			]} />
			<Gallery height="50%" imageInfos={[
				{
					width: 640,
					height: 480,
					image: <img src="/static/images/events/2025/Nativity/nativity3.jpg" alt="Nativity setup" />,
				},
				{
					width: 640,
					height: 480,
					image: <img src="/static/images/events/2025/Nativity/nativity5.jpg" alt="Nativity setup" />,
				},
				{
					width: 1426,
					height: 834,
					image: <img src="/static/images/events/2025/Nativity/nativity6.jpg" alt="Nativity setup" />,
				},
			]} />
			<p className="justify"><span className="tab"></span>Big thanks to the seven Holy Name members who braved the frigid temperatures to set up the Nativity on the St. Joseph lawn! The nativity building was later populated with figures by the St. Joseph School students.</p>
			<br />

			<h1>PAL Lunch</h1>
			<h3>November 2, 2025</h3>
			<Gallery imageInfos={[
				{
					width: 1903,
					height: 1303,
					image: <img src="/static/images/events/2025/PALLunch/pal1.jpg" alt="PAL Lunch" />,
				},
				{
					width: 1922,
					height: 1230,
					image: <img src="/static/images/events/2025/PALLunch/pal2.jpg" alt="PAL Lunch" />,
				},
			]} />
			<p className="justify"><span className="tab"></span>Seven volunteers showed up to help preapre a meal of spaghetti, garlic bread, and fruit. At this lunch, a pre-COVID rule made its reintroduction: the meal has to be eaten inside the facility and not taken away, out to the unknown.</p>
			<br />

			<h1>Installing Pro-Life Crosses</h1>
			<h3>October 3, 2025</h3>
			<Gallery imageInfos={[
				{
					width: 1920,
					height: 1440,
					image: <img src="/static/images/events/2025/Crosses/cross2.jpg" alt="Pro-Life Crosses" />,
				},
				{
					width: 1920,
					height: 1440,
					image: <img src="/static/images/events/2025/Crosses/cross3.jpg" alt="Pro-Life Crosses" />,
				},
				{
					width: 1920,
					height: 1440,
					image: <img src="/static/images/events/2025/Crosses/cross4.jpg" alt="Pro-Life Crosses" />,
				},
			]} />
			<p className="justify"><span className="tab"></span>Begun and completed within a couple of hours, the Holy Name men assisted in hammering down 518 pro-life crosses on the front lawn of St. Joseph's. The weather was calm, the temperature was perfect, and there were cookies at the end! See the <a href="https://www.facebook.com/share/p/1Q4ogCLvug/" target="_blank" rel="noreferrer">parish Facebook post</a> for more pictures.</p>
			<br />

			<h1>The Feast of St. Joseph</h1>
			<h3>March 19, 2025</h3>
			<Gallery imageInfos={[
				{
					width: 2250,
					height: 4000,
					image: <img src="/static/images/events/2025/StJosephFeast/feast1.jpg" alt="Feast of St. Joseph" />,
				},
				{
					width: 4000,
					height: 2250,
					image: <img src="/static/images/events/2025/StJosephFeast/feast2.jpg" alt="Feast of St. Joseph" />,
				},
			]} />
			<p className="justify"><span className="tab"></span>This was the first parish patron feast of its kind hosted at St. Joseph's. The dinner was a great success, with twelve Holy Name men assisting in operations. Partnering with <em>Amici d'Italia</em>, the men prepared thirty-six pans of ziti&mdash; ten of which were donated as leftovers to the Hanover Area Council of Churches. Approximately 110 to 150 people were served after the Liturgy.</p>
			<br />

			<PageEndBlank />
		</div>
	);
};

export default PreviousEvents;